import React from 'react';
import CentersHome from '../../components/Centers/CentersHome';

function index() {
  return (
    <>
        <CentersHome />
    </>
  )
}

export default index